// FAQ Tabs Logic
const tabBtns = document.querySelectorAll('.tab-btn');
const faqSections = document.querySelectorAll('.faq-section');
tabBtns.forEach(btn => {
  btn.addEventListener('click', () => {
    tabBtns.forEach(b => b.classList.remove('active'));
    faqSections.forEach(s => s.classList.remove('active'));
    btn.classList.add('active');
    const target = document.querySelector(`[data-section="${btn.dataset.tab}"]`);
    if(target) target.classList.add('active');
    window.scrollTo({ top: document.querySelector('.page-wrap').offsetTop - 80, behavior: 'smooth' });
  });
});

document.querySelectorAll('[data-tab-link]').forEach(link => {
  link.addEventListener('click', e => {
    e.preventDefault();
    const t = link.dataset.tabLink;
    tabBtns.forEach(b => b.classList.remove('active'));
    faqSections.forEach(s => s.classList.remove('active'));
    const btn = document.querySelector(`[data-tab="${t}"]`);
    const sec = document.querySelector(`[data-section="${t}"]`);
    if(btn) btn.classList.add('active');
    if(sec) sec.classList.add('active');
    window.scrollTo({ top: document.querySelector('.page-wrap').offsetTop - 80, behavior: 'smooth' });
  });
});

// FAQ Accordion Logic
document.querySelectorAll('.faq-question').forEach(btn => {
  btn.addEventListener('click', () => {
    btn.closest('.faq-item').classList.toggle('open');
  });
});
